(function($){
	//Swap the registration modal text and form pre-selection, depending on what type of registration link is clicked (default vs place)
	$(document).on('click', 'a.open-popup-link.register', function(e) {
		swapRegistrationText($(this).hasClass('place'));
	});

	$(document).on('click', '.open-popup-link.register > a', function(e) {
		swapRegistrationText($(this).parent().hasClass('place'));
	});

	function swapRegistrationText(showPlaceText = true) {
		//Make sure the modal exists
		if (!$('#account.standard-modal').length) return;

		//If we have the place class, make sure the places & events are checked
		//And display the correct heading
		if (showPlaceText) {
			//Swap text
			$('#account #register .adventure-registration-text').hide();
			$('#account #register .place-registration-text').show();

			//Check box
			$('form#registration #content_places_events').prop('checked', true);
		}
		//Otherwise, uncheck the place & events
		//And display the VisitList heading
		else {
			//Swap text
			$('#account #register .place-registration-text').hide();
			$('#account #register .adventure-registration-text').show();

			//Uncheck box
			$('form#registration #content_places_events').prop('checked', false);

			//Make sure visitlists are always checked also
			$('form#registration #content_adventure').prop('checked', true);
		}
	}

	$(document).on('click', 'a.open-popup-link, .open-popup-link > a, .et_pb_module.open-popup-link a', function(e) {
		e.preventDefault();

		if(!$(this).hasClass('mp-init')) {
			$(this).magnificPopup({
				type: 'inline',
				// modal: true,
				closeOnBgClick: false,
				closeOnContentClick: false,
				showCloseBtn: true,
				closeBtnInside: true,
				enableEscapeKey: false,
				callbacks: {
					open: function() {
						//
					},
					close: function() {
						//
					}
				}
			}).addClass('mp-init').click();
		}
	});

	//Open the popup from the url, if it exists
	if (window.location.hash && $(window.location.hash).length) {

		// If popup class is on the target, pop it like its hot.
		if($(window.location.hash).hasClass('standard-modal')) {

			//Don't open the account modal if logged in
			if ($('body').hasClass('logged-in') && window.location.hash == '#account') return;

			$.magnificPopup.open({
				items: {
					src: window.location.hash,
				},
				type: 'inline',
				closeOnBgClick: false,
				closeOnContentClick: false,
				showCloseBtn: true,
				closeBtnInside: true,
				enableEscapeKey: false,
				callbacks: {
					open: function() {
						//
					},
					close: function() {
						//
					}
				}
			});
		}

		//Special case for forgot password
		if (window.location.hash == '#password') {
			toggleAccountModalPanel('password');

			$.magnificPopup.open({
				items: {
					src: '#account',
				},
				type: 'inline',
				closeOnBgClick: false,
				closeOnContentClick: false,
				showCloseBtn: true,
				closeBtnInside: true,
				enableEscapeKey: false,
				callbacks: {
					open: function() {
						//
					},
					close: function() {
						//
					}
				}
			});
		}
	}

	//Special rules for clicking links related to the account modal
	$(document).on('click', '.open-popup-link.signin, #account a.signin', function(e) {
		e.preventDefault();

		toggleAccountModalPanel('signin');
	});

	$(document).on('click', '.open-popup-link.register, #account a.register', function(e) {
		e.preventDefault();

		toggleAccountModalPanel('register');
	});

	$(document).on('click', '.open-popup-link.password, #account a.password', function(e) {
		e.preventDefault();

		toggleAccountModalPanel('password');
	});

	function toggleAccountModalPanel(panel) {
		$(`#account .panel:not(#${panel})`).removeClass('active');
		$(`#account .panel#${panel}`).addClass('active');
	}

	/**
	 * Galleries on places
	 */
	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			markup: '<div class="mfp-figure">'+
			            '<div class="mfp-close"></div>'+
			            '<div class="mfp-img"></div>'+
			            theme.selfie_backdrop_download_markup+
			            '<div class="mfp-bottom-bar">'+
			            	'<div class="mfp-title"></div>'+
			            	'<div class="mfp-counter"></div>'+
			            '</div>'+
			        '</div>'
		},
		callbacks: {
			elementParse: function(item) {
				// the class name
				console.log(item);
				if (item && item.el && item.el.length && item.el[0] && item.el[0].className.indexOf('video-link') >= 0) {
					item.type = 'iframe';
				}
				else {
					item.type = 'image';
				}
			}
		}
	});

	/**
	 * Gallery of featured thingies on adventures
	 */
	// $('.single-adventure section.stops .gallery').magnificPopup({
	// 	delegate: '.stop .media a',
	// 	type: 'image',
	// 	tLoading: 'Loading image #%curr%...',
	// 	mainClass: 'mfp-img-mobile',
	// 	gallery: {
	// 		enabled: true,
	// 		navigateByImgClick: true,
	// 		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	// 	},
	// 	image: {
	// 		tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
	// 		markup: '<div class="mfp-figure">'+
	// 		            '<div class="mfp-close"></div>'+
	// 		            '<div class="mfp-img"></div>'+
	// 		            theme.selfie_backdrop_download_markup+
	// 		            '<div class="mfp-bottom-bar">'+
	// 		            	'<div class="mfp-title"></div>'+
	// 		            	'<div class="mfp-counter"></div>'+
	// 		            '</div>'+
	// 		        '</div>'
	// 	},
	// 	callbacks: {
	// 		elementParse: function(item) {
	// 			// the class name
	// 			if (item.el.context.className.indexOf('video') >= 0) {
	// 				item.type = 'iframe';
	// 			}
	// 			else {
	// 				item.type = 'image';
	// 			}
	// 		}
	// 	}
	// });

})(jQuery);
